import { Form, Input, Select, DatePicker, Button, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import PhoneInput, { parsePhoneNumber, PhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { durationOptions, generateTimeSlots } from '../../constants';
import api from '../../api/axios';
import { useAppStore } from '../../store/appStore';
import { useAgenda } from '../../hooks/useAgenda';
import { ApprovedMeetingInterface } from '../../types/approvedMeeting';
import { useQueryClient } from '@tanstack/react-query';

const timeSlots = generateTimeSlots();

interface FormValues {
  organisation: string;
  title: string;
  meetingDate: dayjs.Dayjs;
  meetingTime: string;
  additionalNotes: string | null;
  requesterName: string;
  requesterEmail: string;
  requesterPhone: string;
  setDuration: number;
  agendaId?: number;
  subAgendaId?: number;
  presenter: Array<string | number | { value: string | number; label: string }>;
  admin: Array<string | number | { value: string | number; label: string }>;
  requesterDesignation: string;
  attendees: Array<{
    fullName: string;
    email: string;
    designation: string;
  }>;
  assignedUserIds: string[]; // emails of PGP users
}

interface EditApprovedMeetingModalProps {
  meetingData: ApprovedMeetingInterface;
  onUpdate: (values: FormValues, id: string) => void;
  closeStatusModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const EditApprovedMeetingModal: React.FC<EditApprovedMeetingModalProps> = ({
  closeStatusModal,
  meetingData,
  onUpdate,
}) => {
  const [form] = useForm<FormValues>();
  const hosts = useAppStore((state:any) => state.hosts);
  const arManagers = useAppStore((state) => state.arManagers);
  const [phone, setPhone] = useState<PhoneNumber | undefined>();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
    //  const user = useAppStore((state:any) => state.user);
     console.log("username is yhat fssdg",hosts?.role?.roleName)
// const isMeetingManager = hosts[0].role?.roleName === "Meeting Manager";
// console.log('RTTTYUUPPPMMKLLLL',isMeetingManager)

const user1 = useAppStore((state: any) => state.user);
console.log("Logged in user role:", user1?.role?.roleName);

const profile = useAppStore((state: any) => state.profile);

console.log("Logged in usermmmmmmm:", profile);
console.log("Logged in roleeeeee:", profile?.roleName);

const isMeetingManager = profile?.
user?.role?.roleName === "Meeting Manager";
console.log("cureent statusss",isMeetingManager)
const disableAll = isMeetingManager;

const isMarketingManager = profile?.
user?.role?.roleName === "Marketing Manager";
console.log("cureent statusss",isMeetingManager)
const disableAllMarketing = isMarketingManager;




  useEffect(() => {
    if (meetingData) {
      // ✅ Combine attendees
      const allAttendees =
        meetingData.meetingAttendee?.map((item) => ({
          fullName: item.requestAttendee?.name || '',
          email: item.requestAttendee?.email || '',
          department: item.requestAttendee?.designation || '',
        })) || [];

 



      // ✅ Derive presenter/admin from meetingUser role
      const presenterIds =
        meetingData.meetingUser
          ?.filter((u:any) => u.user?.role?.roleName?.includes('AR Manager'))
          .map((u) => u.user.id) || [];

      const adminIds =
        meetingData.meetingUser
          ?.filter((u:any) => u.user?.role?.roleName?.includes('Meeting Manager'))
          .map((u) => u.user.id) || [];

      const presenterLabelValues = presenterIds
        .map((id) => {
          const manager = arManagers.find((p) => String(p.id) === String(id));
          return manager ? { value: id, label: manager.name } : null;
        })
        .filter((item:any): item is { value: number; label: string } => item !== null);

      const adminLabelValues = adminIds
        .map((id) => {
          const host = hosts.find((h:any) => String(h.id) === String(id));
          return host ? { value: id, label: host.name } : null;
        })
        .filter((item:any): item is { value: number; label: string } => item !== null);

      // ✅ Derive PGP external user emails
      const pgpUserEmails =
        meetingData.meetingExternalUser
          ?.map((ext) => ext.externalUser?.email || '')
          .filter(Boolean) || [];

          console.log("++++++",meetingData)

      // ✅ Populate form
      form.setFieldsValue({
        organisation: meetingData.meetingRequest.organisation,
        title: meetingData.title,
        meetingDate: dayjs(meetingData.meetingDate),
        meetingTime: dayjs(meetingData.meetingTime, 'HH:mm:ss').format('HH:mm'),
        additionalNotes: meetingData.additionalNotes,
        setDuration: Number(meetingData.setDuration) || 60,
        requesterName: meetingData.requestor.requesterName,
        requesterEmail: meetingData.requestor.requesterEmail,
        requesterPhone: meetingData.requestor.requesterPhone,
        requesterDesignation: meetingData.requestor.requesterDesignation,
        agendaId: meetingData.agendaId,
        subAgendaId: meetingData.subAgendaId,
        attendees: allAttendees,
        admin: adminLabelValues,
        presenter: presenterLabelValues,
        assignedUserIds: pgpUserEmails,
      });

      const parsedPhone = parsePhoneNumber(meetingData.requestor.requesterPhone || '');
      setPhone(parsedPhone);
    }
  }, [meetingData, form, arManagers, hosts]);



  const handleSubmit = async (values: FormValues) => {
    setLoading(true);
    try {
      const presenterIds = (values.presenter || []).map(
        (v: string | number | { value: string | number; label: string }) =>
          typeof v === 'object' && v !== null ? v.value : v
      );
      const adminIds = (values.admin || []).map(
        (v: string | number | { value: string | number; label: string }) =>
          typeof v === 'object' && v !== null ? v.value : v
      );
      const payloadData = {
        title: values.title,
        // organization: values.organisation,
        meetingDate: values.meetingDate.format('YYYY-MM-DD'),
        meetingTime: values.meetingTime,
        additionalNotes: values.additionalNotes,
        setDuration: Number(values.setDuration),
        agendaId: values.agendaId,
        subAgendaId: values.subAgendaId,
        attendees: values.attendees.map((a:any) => ({
          name: a.fullName,
          email: a.email,
          designation: a.department,
        })),
        externalUsers: values.assignedUserIds.map((email) => ({
          name: 'External User',
          email,
          department: 'External',
        })),
        assignedUserIds: [...presenterIds, ...adminIds],
      };

      console.log('📤 PATCH Payload:', payloadData);

      const response = await api.post(
        `${import.meta.env.VITE_API_BASE_URL}/meetings/${meetingData.meetingId}`,
        payloadData
      );

      console.log('✅ Meeting updated:', response);
      onUpdate(values, String(meetingData.meetingId));
      closeStatusModal(false);
      // Invalidate queries to auto-refresh lists without full page reload
      queryClient.invalidateQueries({ queryKey: ['meetingsByStatus'] });
      queryClient.invalidateQueries({ queryKey: ['meetings'] });
      queryClient.invalidateQueries({ queryKey: ['approved-meeting'] });
      message.success('Meeting updated successfully');
    } catch (error) {
      console.error('❌ Error updating meeting:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setPhone(undefined);
    closeStatusModal(false);
  };

  const { data: agenda } = useAgenda();
  const selectedAgendaId = Form.useWatch('agendaId', form);
  const subAgendaOptions =
    (agenda || []).find(
      (a: { agendaId: number; subAgendas?: Array<{ subAgendaId: number; title: string }> }) =>
        a.agendaId === selectedAgendaId
    )?.subAgendas || [];

// Re-apply subAgendaId after subAgendaOptions load
// useEffect(() => {
//   if (!meetingData) return;
//   if (!subAgendaOptions || subAgendaOptions.length === 0) return;

//   // If form already has the correct value but label is not showing, re-set
//   const currentValue = meetingData.subAgendaId;

//   // Check if that ID exists in the loaded options
//   const exists = subAgendaOptions.some(
//     (s) => s.subAgendaId === currentValue
//   );

//   if (exists) {
//     form.setFieldsValue({
//       subAgendaId: currentValue,
//     });
//   }
// }, [subAgendaOptions, meetingData, form]);



  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit} className="mt-4">
      {/* Plant Info */}
      <div className="bg-gray-50 !p-4 rounded-lg !mb-4">
        <h3 className="text-lg font-semibold mb-2">Plant Information</h3>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Plant Name</label>
            <div className="mt-1 text-sm text-gray-900">Kosamba</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Location</label>
            <div className="mt-1 text-sm text-gray-900">Kosamba, Gujarat</div>
          </div>
        </div>
      </div>

      {/* Meeting Info */}
      <div className="">
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input placeholder="Title" disabled={disableAll} />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item label="Date" name="meetingDate" rules={[{ required: true }]}>
          <DatePicker className="w-full" disabled={disableAll}/>
        </Form.Item>

        <Form.Item label="Time" name="meetingTime" rules={[{ required: true }]}>
          <Select placeholder="Select time" disabled={disableAll}>
            {timeSlots.map((time) => (
              <Select.Option key={time.value} value={time.value}>
                {time.key}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Form.Item label="Agenda" name="agendaId" rules={[{ required: true }]}>
          <Select
            placeholder="Select agenda"
            onChange={() => form.setFieldsValue({ subAgendaId: undefined })}
            disabled={disableAll}
          >
            {(agenda || []).map((ag: { agendaId: number; title: string }) => (
              <Select.Option key={ag.agendaId} value={ag.agendaId}>
                {ag.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item label="Sub Agenda" name="subAgendaId">
          <Select placeholder="Select sub agenda" disabled={!selectedAgendaId}>
            {subAgendaOptions.map((s: { subAgendaId: number; title: string }) => (
              <Select.Option key={s.subAgendaId} value={s.subAgendaId}>
                {s.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}
        <Form.Item label="Sub Agenda" name="subAgendaId">
  <Select placeholder="Select sub agenda" disabled={!selectedAgendaId}>
    {subAgendaOptions.map((s) => (
      <Select.Option key={s.subAgendaId} value={s.subAgendaId}>
        {s.title}
      </Select.Option>
    ))}
  </Select>
</Form.Item>

      </div>

      <Form.Item label="Duration" name="setDuration">
        <Select placeholder="Select duration" showSearch={false}  optionFilterProp="label">
          {durationOptions.map((opt) => (
            <Select.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Additional Notes" name="additionalNotes">
        <Input.TextArea rows={3} placeholder="Additional notes (optional)" />
      </Form.Item>

      {/* External Users */}
      <Form.Item
        label="PGP Users"
        name="assignedUserIds"
        rules={[
          {
            validator: (_, value) => {
              if (!value || value.length === 0) return Promise.resolve();
              const invalid = value.filter((v: string) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
              return invalid.length
                ? Promise.reject(new Error(`Invalid emails: ${invalid.join(', ')}`))
                : Promise.resolve();
            },
          },
        ]}
      >
        <Select mode="tags" open={false} placeholder="Type email and press Enter" disabled={disableAllMarketing}/>
      </Form.Item>

      {/* Presenter/Admin */}
      <div className="flex gap-4">
        <Form.Item
          label="Presenter"
          name="presenter"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || value.length < 1)
                  return Promise.reject(new Error('Please add at least one presenter'));
                if (value.length > 8)
                  return Promise.reject(new Error('You can add a maximum of 8 presenters'));
                return Promise.resolve();
              },
            },
          ]}
          className="flex-1"
        >
          <Select
            mode="multiple"
            placeholder="Select presenter"
            labelInValue
            optionFilterProp="children"
            disabled={disableAllMarketing}
          >
            {arManagers.map((p) => (
              <Select.Option key={`presenter-${p.id}`} value={p.id} title={p.name}>
                {p.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Meeting Managers"
          name="admin"
          className="flex-1"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || value.length < 1)
                  return Promise.reject(new Error('Please add at least one admin'));
                if (value.length > 5)
                  return Promise.reject(new Error('You can add a maximum of 5 meeting managers'));
                return Promise.resolve();
              },
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select Meeting Managers"
            labelInValue
            optionFilterProp="children"
            disabled={disableAllMarketing}
          >
            {hosts.map((p:any) => (
              <Select.Option key={`admin-${p.id}`} value={p.id} title={p.name}>
                {p.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>

      {/* Requestor Info */}
      <div className="border-t !pt-4 !mt-4">
        <h3 className="text-lg font-semibold mb-4">Requestor Information</h3>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item label="Name" name="requesterName">
            <Input disabled />
          </Form.Item>
          <Form.Item label="Email" name="requesterEmail">
            <Input disabled />
          </Form.Item>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Form.Item label="Phone Number" name="requesterPhone">
            <PhoneInput
              international
              defaultCountry={phone?.country || 'IN'}
              value={phone?.number || ''}
              onChange={(val) => {
                const parsed = parsePhoneNumber(val || '');
                setPhone(parsed);
                form.setFieldsValue({ requesterPhone: val });
              }}
              placeholder="Enter phone number"
              className="custom-phone-input cursor-not-allowed bg-[#f5f4f4]"
              disabled
            />
          </Form.Item>
          <Form.Item label="Organisation" name="organisation" rules={[{ required: true }]}>
            <Input disabled />
          </Form.Item>
        </div>
      </div>

      {/* Attendees */}
      <div className="border-t !pt-4 !mt-4">
        <Form.List name="attendees">
          {(fields, { add, remove }) => (
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Requested Attendees</h3>
                <Button type="dashed" onClick={() => add()} disabled={disableAll}>
                  + Add Attendee
                </Button>
              </div>
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="grid grid-cols-4 gap-4">
                  <Form.Item {...restField} name={[name, 'fullName']} rules={[{ required: true }]}>
                    <Input placeholder="Name" disabled={disableAll}/>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'email']}
                    rules={[{ required: true, type: 'email' }]}
                  >
                    <Input placeholder="Email" disabled={disableAll}/>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'department']}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Department" disabled={disableAll}/>
                  </Form.Item>
                  <Button type="link" danger onClick={() => remove(name)} disabled={disableAll}>
                    Remove
                  </Button>
                </div>
              ))}
            </div>
          )}
        </Form.List>
      </div>

      {/* Footer */}
      <div className="flex justify-end gap-2 !mt-6 !pt-4 border-t">
        <Button onClick={handleCancel}>Cancel</Button>
        <Button type="primary" htmlType="submit" loading={loading}>
          Update Meeting
        </Button>
      </div>
    </Form>
  );
};

export default EditApprovedMeetingModal;
